import Button from '@segment/matcha/components/Button'

import SignupButton from '@segment/matcha/recipes/SignupButton'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import type { PageConfig } from '@segment/contexts/page'

import FreePlanImage from './FreePlanImage'
import TeamPlanImage from './TeamPlanImage'
import BusinessPlanImage from './BusinessPlanImage'

const data = (config: PageConfig) => {
  return [
    {
      key: `free`,
      title: `Free`,
      image: <FreePlanImage />,
      contentHeading: `Free plan`,
      list: [
        {
          name: `Collect data from 2 sources`,
          check: true,
        },
        {
          name: `Send data to unlimited destinations`,
          check: true,
        },
        {
          name: `Up to 1,000 monthly users`,
          check: true,
        },
        {
          name: `Enforce data quality (Add-on)`,
          check: false,
        },
        {
          name: `Build a complete view of your customer`,
          check: false,
        },
        {
          name: `Orchestrate personalized Journeys (Add-on)`,
          check: false,
        },
        {
          name: `Deliver omnichannel experiences (Add-on)`,
          check: false,
        },
        {
          name: `Transform and enrich your data`,
          check: false,
        },
        {
          name: `Set granular user roles and permissions`,
          check: false,
        },
      ],
      button: <SignupButton variant="outlined">Create a free account</SignupButton>,
    },
    {
      key: `team`,
      title: `Team`,
      image: <TeamPlanImage />,
      list: [
        {
          name: `Collect data from unlimited sources`,
          check: true,
        },
        {
          name: `Send data to unlimited destinations`,
          check: true,
        },
        {
          name: `10,000 monthly users included`,
          check: true,
        },
        {
          name: `Enforce data quality (Add-on)`,
          check: false,
        },
        {
          name: `Build a complete view of your customer`,
          check: false,
        },
        {
          name: `Orchestrate personalized Journeys (Add-on)`,
          check: false,
        },
        {
          name: `Deliver omnichannel experiences (Add-on)`,
          check: false,
        },
        {
          name: `Transform and enrich your data`,
          check: false,
        },
        {
          name: `Set granular user roles and permissions`,
          check: false,
        },
      ],
      hint: `14-day free trial`,
      button: <SignupButton>Try for free</SignupButton>,
    },
    {
      key: `business`,
      title: `Business`,
      image: <BusinessPlanImage />,
      list: [
        {
          name: `Collect data from unlimited sources`,
          check: true,
        },
        {
          name: `Send data to unlimited destinations`,
          check: true,
        },
        {
          name: `Custom volume`,
          check: true,
        },
        {
          name: `Enforce data quality (Add-on)`,
          check: true,
        },
        {
          name: `Build a complete view of your customer`,
          check: true,
        },
        {
          name: `Orchestrate personalized Journeys (Add-on)`,
          check: true,
        },
        {
          name: `Deliver omnichannel experiences (Add-on)`,
          check: true,
        },
        {
          name: `Transform and enrich your data`,
          check: true,
        },
        {
          name: `Set granular user roles and permissions`,
          check: true,
        },
        {
          name: `Enable HIPAA-eligible Workspaces (Add-on)`,
          check: true,
        },
      ],
      button: (
        <Button variant="outlined" size="large" color="primary" href={getAbsoluteUrl(`/demo/`, config)}>
          Get a demo
        </Button>
      ),
    },
  ]
}

export default data
